import React, { useState } from 'react';
import { Plus, Search, AlertTriangle, MoreHorizontal } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../components/ui/DropdownMenu';
import { mockInventory } from '../data/mockData';
import { formatCurrency } from '../lib/utils';
import { Badge } from '../components/ui/Badge';
export function Inventory() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredItems = mockInventory.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) || item.sku.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="h-full flex flex-col space-y-6" data-id="element-531">
      <div className="flex items-center justify-between" data-id="element-532">
        <div data-id="element-533">
          <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-534">
            Estoque
          </h1>
          <p className="text-muted-foreground mt-1" data-id="element-535">
            Controle de peças e produtos.
          </p>
        </div>
        <Button className="gap-2" data-id="element-536">
          <Plus className="h-4 w-4" data-id="element-537" /> Novo Item
        </Button>
      </div>

      <div className="flex items-center gap-2 max-w-md" data-id="element-538">
        <div className="relative flex-1" data-id="element-539">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" data-id="element-540" />
          <Input placeholder="Buscar por nome ou SKU..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-541" />
        </div>
      </div>

      <div className="rounded-xl border bg-card flex-1 overflow-hidden flex flex-col" data-id="element-542">
        <div className="flex-1 overflow-auto" data-id="element-543">
          <Table data-id="element-544">
            <TableHeader data-id="element-545">
              <TableRow data-id="element-546">
                <TableHead data-id="element-547">Produto</TableHead>
                <TableHead data-id="element-548">SKU</TableHead>
                <TableHead data-id="element-549">Localização</TableHead>
                <TableHead className="text-right" data-id="element-550">Custo</TableHead>
                <TableHead className="text-right" data-id="element-551">Venda</TableHead>
                <TableHead className="text-center" data-id="element-552">Qtd</TableHead>
                <TableHead className="w-[50px]" data-id="element-553"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-554">
              {filteredItems.map(item => {
              const isLowStock = item.quantity <= item.minQuantity;
              return <TableRow key={item.id} data-id="element-555">
                    <TableCell data-id="element-556">
                      <div className="font-medium" data-id="element-557">{item.name}</div>
                      <div className="text-xs text-muted-foreground" data-id="element-558">
                        {item.supplier}
                      </div>
                    </TableCell>
                    <TableCell data-id="element-559">
                      <span className="font-mono text-sm text-muted-foreground" data-id="element-560">
                        {item.sku}
                      </span>
                    </TableCell>
                    <TableCell data-id="element-561">{item.location}</TableCell>
                    <TableCell className="text-right" data-id="element-562">
                      {formatCurrency(item.costPrice)}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-563">
                      {formatCurrency(item.sellPrice)}
                    </TableCell>
                    <TableCell className="text-center" data-id="element-564">
                      <div className="flex items-center justify-center gap-2" data-id="element-565">
                        <span className={`font-medium ${isLowStock ? 'text-destructive' : ''}`} data-id="element-566">
                          {item.quantity}
                        </span>
                        {isLowStock && <AlertTriangle className="h-4 w-4 text-automotive-orange" data-id="element-567" />}
                      </div>
                    </TableCell>
                    <TableCell data-id="element-568">
                      <DropdownMenu data-id="element-569">
                        <DropdownMenuTrigger asChild data-id="element-570">
                          <Button variant="ghost" className="h-8 w-8 p-0" data-id="element-571">
                            <span className="sr-only" data-id="element-572">Abrir menu</span>
                            <MoreHorizontal className="h-4 w-4" data-id="element-573" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" data-id="element-574">
                          <DropdownMenuLabel data-id="element-575">Ações</DropdownMenuLabel>
                          <DropdownMenuItem data-id="element-576">Editar Item</DropdownMenuItem>
                          <DropdownMenuItem data-id="element-577">Ajustar Estoque</DropdownMenuItem>
                          <DropdownMenuSeparator data-id="element-578" />
                          <DropdownMenuItem className="text-destructive focus:text-destructive" data-id="element-579">
                            Excluir
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>;
            })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>;
}